"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const icalApiFactory = (http, prefix = '/ical_validator') => ({
    validate(url) {
        return http.post(`${prefix}?url=${url}`);
    }
});
exports.default = icalApiFactory;
//# sourceMappingURL=ical.js.map